import React, { useState } from "react";
import {
	Modal,
	Box,
	Button,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { t } from "i18next";

type DeleteModalProps = {
	open: boolean;
	confirmMessage: string | null;
	isDeleting: boolean;
	onCancel: () => void;
	// onDelete: () => void;
	successName?: string;
	onDelete: (selectedApiCategory?: string) => void;
	filteredApiCategories?: Array<any>;
};

const DeleteModal: React.FC<DeleteModalProps> = ({
	open,
	confirmMessage,
	isDeleting,
	onCancel,
	onDelete,
	successName,
	filteredApiCategories,
}) => {
	const [selectedApiCategory, setSelectedApiCategory] = useState<string | undefined>("");

	const handleDeleteClick = () => {
		onDelete(selectedApiCategory);
	};
	return (
		<Modal
			open={open}
			onClose={onCancel}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
		>
			<Box
				sx={{
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: 600,
					bgcolor: "background.paper",
					border: "2px solid #000",
					boxShadow: 24,
					p: 4,
				}}
			>
				<Box width="100%">
					<Box mb={2}>{confirmMessage}</Box>

					{filteredApiCategories?.length > 0 && (
						<>
							<Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
								{t(
									" The field below is optional. You can choose to leave it blank if you do not wish to move your data to any other category."
								)}
							</Typography>
							<FormControl disabled={isDeleting} sx={{ mb: 2, width: "50%" }}>
								<InputLabel id="api-category-label">
									{t("Select API Category")}
								</InputLabel>
								<Select
									labelId="api-category-label"
									value={selectedApiCategory}
									onChange={(e) => setSelectedApiCategory(e.target.value)}
									label={t("Select API Category")}
									defaultValue=""
								>
									{filteredApiCategories?.map((category) => (
										<MenuItem key={category._id} value={category.type}>
											{category.type}
										</MenuItem>
									))}
								</Select>
							</FormControl>
						</>
					)}
					<Box
						sx={{
							display: "flex",
							gap: 1,
						}}
					>
						<LoadingButton
							onClick={handleDeleteClick}
							variant="contained"
							color="error"
							loading={isDeleting}
							id="snr-ai-DeleteModal-deleteButton"
						>
							{successName || t("Delete")}
						</LoadingButton>
						<Button
							onClick={onCancel}
							color="primary"
							variant="outlined"
							id="snr-ai-DeleteModal-cancelButton"
						>
							{t("Cancel")}
						</Button>
					</Box>
				</Box>
			</Box>
		</Modal>
	);
};

export default DeleteModal;
